export default function PageIsGoneException() {
  this.name = "PAGE_IS_GONE";
  this.message = "410";
}
